/**
 * Compact metric pill: icon + label + value.
 *
 * A small, theme-aware presentational component reused across table cells and
 * info panels so derived data reads consistently everywhere.
 *
 * @param {object}  props
 * @param {string}  props.icon   - Boxicons class (e.g. "bx-gas-pump").
 * @param {string}  props.label  - Muted prefix label.
 * @param {*}       props.value  - The value to emphasise.
 * @param {string}  props.color  - Bootstrap theme color (subtle background).
 * @param {string}  props.title  - Optional native tooltip text.
 */
const MetricBadge = ({
  icon,
  label,
  value,
  color = "secondary",
  title,
}) => (
  <span
    title={title}
    className={`badge bg-${color}-subtle text-${color} d-inline-flex align-items-center gap-1 fw-medium`}
  >
    {icon && <i className={`bx ${icon}`} />}
    {label && <span className="opacity-75 fw-normal">{label}</span>}
    <span>{value}</span>
  </span>
)

export default MetricBadge
